import loadable from '@loadable/component'

export default [
  {
    path: '/GiftBook',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-game-GiftBook" */ '~/pages/GiftBook')
    ),
  },
  {
    path: '/GiftBook/IntroBook',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GiftBook-IntroBook" */ '~/pages/GiftBook/IntroBook'
        )
    ),
  },
  {
    path: '/GiftBook/IntroWord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GiftBook-IntroWord" */ '~/pages/GiftBook/IntroWord'
        )
    ),
  },
  {
    path: '/GiftBook/Rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GiftBook-Rule" */ '~/pages/GiftBook/Rule'
        )
    ),
  },
]
